module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.readShow == 'ReadShow') ? _c('rankErrorRead', {
    attrs: {
      "workData": _vm.exampaperData,
      "checkedResource": _vm.checkedResource,
      "answerData": _vm.useAnswer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readShow == 'TextShow') ? _c('rankErrorText', {
    attrs: {
      "workData": _vm.exampaperData,
      "checkedResource": _vm.checkedResource,
      "answerData": _vm.useAnswer
    }
  }) : _vm._e(), _vm._v(" "), (_vm.readShow == 'OnlineShow') ? _c('rankErrorOnline', {
    attrs: {
      "workData": _vm.exampaperData,
      "checkedResource": _vm.checkedResource,
      "answerData": _vm.useAnswer,
      "moduleId": _vm.moduleId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d35696","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rankError/rankError.vue
// module id = 1182
// module chunks = 1